import useSWR, { SWRResponse, Key } from 'swr';
import { AxiosError } from 'axios';

import {
  Parameter$getReservationFlowCustomFields,
  Response$getReservationFlowCustomFields$Status$200,
} from '../../../../openapi/generated/apiClient';
import { useClientSideApiClient } from '../../../../openapi/axiosClient';

export interface UseGetReservationFlowCustomFieldsParams {
  parameter: Parameter$getReservationFlowCustomFields;
  isDisabled?: boolean;
}

export type UseGetReservationFlowCustomFieldsValue = SWRResponse<
  Response$getReservationFlowCustomFields$Status$200['application/json'],
  AxiosError
>;

export const getGetReservationFlowCustomFieldsKey: (params: {
  parameter: Parameter$getReservationFlowCustomFields;
}) => Key = ({ parameter }) => {
  return {
    path: '/api/reservation_flow/merchants/{merchant_public_id}/event_scheme/resources/{resource_public_id}/custom_fields',
    parameter,
  };
};

export const useGetReservationFlowCustomFields: (
  params: UseGetReservationFlowCustomFieldsParams,
) => UseGetReservationFlowCustomFieldsValue = ({ parameter, isDisabled }) => {
  const client = useClientSideApiClient();

  const key = !isDisabled
    ? getGetReservationFlowCustomFieldsKey({ parameter })
    : null;

  const fetcher: () => Promise<
    Response$getReservationFlowCustomFields$Status$200['application/json']
  > = async () => {
    try {
      const result = await client.getReservationFlowCustomFields({
        parameter,
      });

      return result;
    } catch (error) {
      throw error;
    }
  };

  return useSWR(key, fetcher);
};
